import React from "react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";

import axios from "../../../../../../axios-instance";
import { getHeaders } from "../../../../../../helpers/getHeaders";
import { getSeatDescription } from "../../../../../../helpers/getSeatDescription";


const MySwal = withReactContent(Swal);
const closeModalHandler = (e) => {
  MySwal.close();
};

export const ConfirmRefundTicketsModal = ({
  token,
  seats,
  setActionLoading,
  getEventTransactions,
}) => {
  const refundTicketsHandler = () => {
    const idsSeats = seats.map((seat) => seat.id);
    setActionLoading(true);
    closeModalHandler();

    axios
      .post(`/ManageTransactions/Refund`, idsSeats, {
        headers: getHeaders(token),
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            toast.success("Tickets successfully refunded");
            getEventTransactions(token);
            MySwal.close();
          } else {
            toast.error("Tickets not refunded");
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error("Tickets not refunded");
      })
      .finally(() => {
        setActionLoading(false)
      });
  };

  return (
    <>
      <div className="seats-list">
        <span>Tickets that will be refunded:</span>
        {seats.map((seat) => (
          <span key={seat.id}>{getSeatDescription(seat)}</span>
        ))}
      </div>
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled"
          onClick={refundTicketsHandler}
        >
          Refund
        </button>
      </div>
    </>
  );
};
